// eslint-disable-next-line import/prefer-default-export
export const BidProfileEditTab = Object.freeze({
    Form: 0,
    Summary: 1,
    Dashboard: 2,
});
